// src/pages/Aboutus.js
import React from "react";

export default function Aboutus() {
  const steps = [
    {
      title: "Step 1: Create Your Profile",
      text: "Sign up, add details about yourself, and set your trading preferences.",
      icon: "👤",
    },
    {
      title: "Step 2: List Your Items",
      text: "Upload pictures, describe what you’re offering, and mention what you’re looking for in return.",
      icon: "📋",
    },
    {
      title: "Step 3: Explore & Find Matches",
      text: "Browse thousands of listings across different categories. Use filters to find the perfect trade.",
      icon: "🔍",
    },
    {
      title: "Step 4: Make & Receive Offers",
      text: "Negotiate directly with other users by sending and receiving trade requests.",
      icon: "💬",
    },
    {
      title: "Step 5: Swap & Enjoy!",
      text: "Finalize the deal, arrange the exchange, and enjoy your newly swapped item.",
      icon: "🤝",
    },
  ];

  return (
    <div style={page}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&family=League+Spartan:wght@700&display=swap');
      `}</style>

      {/* ================= FULL-WIDTH HERO ================= */}
      <section style={heroSection}>
        <h1 style={heroTitle}>About Us</h1>
        <p style={heroSubtitle}>
          Learn how Swapiify is redefining trading with sustainability, community, and smarter exchanges.
        </p>
      </section>

      {/* ================= MAIN CONTENT CONTAINER ================= */}
      <div style={container}>

        {/* SECTION 1 */}
        <section style={section}>
          <div style={imgCol}>
            <img
              src="https://swapiify.com/wp-content/uploads/2025/02/erone-stuff-Iv-SnVK3tQc-unsplash-768x768.png"
              style={imgBox}
              alt="about"
            />
          </div>

          <div style={textCol}>
            <h2 style={h2}>Turning Unwanted Goods into Valuable Treasures</h2>
            <p style={p}>
              <strong>Redefining the Way You Trade</strong><br />
              At Swapiify, we believe in the power of exchange. Why let your unused items gather <br />
               dust when someone else might need them? Our platform brings people together to swap goods in a seamless, cash-free way—making trading smarter, more sustainable, and fun!
            </p>
          </div>
        </section>

        {/* SECTION 2 */}
        <section style={section}>
          <div style={textCol}>
            <h2 style={h2}>Why Bartering Makes Sense?</h2>
            <p style={p}>At Swapiify, we don’t just see bartering as a way to trade items; we see it as a mindset shift. Here’s why bartering is a smart choice:</p>
            <ul style={ul}>
              <li><strong>Reduces Unnecessary Purchases:</strong> Instead of buying new items, bartering allows you to refresh your belongings without the need for spending.</li>
              <li><strong>Fosters Sustainability:</strong> Every trade helps reduce waste by recycling items and making sure they find a new purpose.</li>
              <li><strong>Strengthens Community:</strong> Trading builds connections, fosters trust, and creates opportunities for collaboration with others in your community.</li>
            </ul>
          </div>

          <div style={imgCol}>
            <img
              src="https://swapiify.com/wp-content/uploads/2025/02/swapiify-Logo-02-28-2025_11_34_AM-e1757406099371.png"
              style={imgBox}
              alt="icon"
            />
          </div>
        </section>

        {/* SECTION 3 */}
        <section style={section}>
          <div style={imgCol}>
            <img
              src="https://swapiify.com/wp-content/uploads/2025/02/swapiify-Logo-02-28-2025_11_38_AM-e1757406125521.png"
              style={imgBox}
              alt="circular"
            />
          </div>

          <div style={textCol}>
            <h2 style={h2}>Why We Believe in the Circular Economy?</h2>
            <p style={p}>
               The circular economy is at the heart of what we do at Swapiify. We believe in creating a system where products are kept in use for as long as possible, and resources are used more efficiently. By swapping instead of buying new, you’re helping keep goods in circulation, extend their lifespan, and reduce the need for additional manufacturing.
            </p>
            <p style={p}>
              Swapiify provides a simple, intuitive way for everyone to participate in this sustainable model. It’s a win-win for the planet and for you—turn your unused items into something valuable and help make a positive environmental impact
            </p>
          </div>
        </section>

        {/* HOW SWAPIFY WORKS EXACT SECTION */}
        <div style={stepsWrap}>
          <h2 style={stepsTitle}>How Swapiify Works?</h2>

          <div style={stepsRow}>
            {steps.map((s, i) => (
              <div key={i} style={stepCard}>
                <div style={stepIcon}>{s.icon}</div>
                <h4 style={stepHeading}>{s.title}</h4>
                <p style={stepText}>{s.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* FOUNDER */}
        <section style={founderSection}>
          <img
            src="https://swapiify.com/wp-content/uploads/2025/09/WhatsApp-Image-2025-09-07-at-2.28.14-PM-e1757405859560.jpeg"
            alt="founder"
            style={founderImg}
          />

          <div>
            <h3 style={h2}>Meet The Founder</h3>

            <p style={p}>
              Hey, I’m Samaira, the brain (and chaos) behind Swapify.
              A high school sophomore who got tired of watching closets
              explode with stuff people don’t use while others keep buying more.<br />
              So I thought <br />
            
              why not just swap it?<br />
              Clothes, books, shoes, that random guitar gathering dust…
              give it a second life.
            </p>

            <p style={p}>
              Swapify isn’t charity, and it’s not your average resale app.<br />
              It’s bartering rebranded — bold, fun, and unapologetically Gen Z.
            </p>

            <p style={p}>
              We’re not here to guilt you into “saving the planet”;
              we’re here to prove sustainability can be stylish, social,
              and actually addictive.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

/* ------------------------------- STYLES ------------------------------- */

const page = {
  fontFamily: "Roboto, sans-serif",
  background: "#fff",
  paddingBottom: "60px",
};

/* -------- FULL WIDTH HERO (MATCHES YOUR SCREENSHOT) -------- */
const heroSection = {
  width: "100%",
  background: "#6a2d57",
  padding: "80px 20px",
  textAlign: "center",
  margin: 0,
  borderRadius: 0,
  marginBottom: "60px",
};

const heroTitle = {
  fontSize: "48px",
  fontFamily: "League Spartan, sans-serif",
  color: "#ff8b5a",
  marginBottom: "10px",
};

const heroSubtitle = {
  fontSize: "16px",
  color: "#ffffffff",
  maxWidth: "700px",
  margin: "0 auto",
  lineHeight: 1.6,
};

const container = {
  maxWidth: "1650px",
  margin: "0 auto",
  padding: "20px",
};

const section = {
  display: "grid",
  maxWidth: "1300px",
  marginTop: "70px",
  margin: "auto",
  gridTemplateColumns: "1fr 1fr",
  alignItems: "center",
  gap: "40px",
};

const imgCol = { width: "100%" };

const imgBox = {
  width: "100%",
  borderRadius: "0px",
  objectFit: "cover",
  background: "#eee",
};

const textCol = {};

const h2 = {
  fontSize: "44px",
  marginBottom: "12px",
  fontFamily: "League Spartan, sans-serif",
};

const p = {
  fontSize: "15px",
  color: "#444",
  lineHeight: 1.6,
};

const ul = {
  paddingLeft: "18px",
  lineHeight: 1.7,
};

/* HOW SWAPIFY WORKS EXACT */
const stepsWrap = {
  marginTop: "80px",
      padding: "70px 0 90px",
    backgroundColor: "#ffffffff ",
  textAlign: "center",
};

const stepsTitle = {
  fontFamily: "League Spartan, sans-serif",
    fontSize: "2.0rem",
    textAlign: "center",
    marginBottom: "40px",
    color: "#702963",
    fontWeight: "800",
};

const stepsRow = {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "20px",
    maxWidth: "1500px",
    margin: "0 auto",
};

const stepCard = {
    backgroundColor: "#ccaac6",
    borderRadius: "18px",
    padding: "35px 25px",
    textAlign: "center",
    minHeight: "240px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.05)",
};

const stepIcon = {
    fontSize: "38px",
    color: "#702963",
    marginBottom: "18px",
};

const stepHeading = {
    fontSize: "1.05rem",
    fontWeight: "700",
    color: "#ffffffff",
    marginBottom: "12px",
};

const stepText = {
    fontSize: "1rem",
    color: "#ffffffff",
    maxWidth: "235px",
    margin: "auto",
    opacity: 0.95,
    lineHeight: 1.55,
    margin: 0,
};

/* FOUNDER */
const founderSection = {
  maxWidth: "1200px",
  margin: "auto",
  marginTop: "60px",
  display: "grid",
  gridTemplateColumns: "350px 1fr",
  gap: "30px",
  alignItems: "center",
};

const founderImg = {
  width: "100%",
  height: "300px",
  objectFit: "cover",
  borderRadius: "10px",
};
